const authRoutes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("./pages/Login.vue"),
    meta: {
      auth: false
    }
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("./pages/Logout.vue")
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("./pages/Register.vue"),
    meta: {
      auth: false
    }
  },
  {
    path: "/need_confirm",
    name: "NeedConfirm",
    component: () => import("./pages/ConfirmEmail.vue")
  },
  {
    path: "/register_success",
    name: "RegisterSuccess",
    component: () => import("./pages/RegisterSuccess.vue")
  },
  {
    path: "/recover",
    name: "Recover",
    component: () => import("./pages/Recover.vue")
  },
  {
    path: "/password",
    name: "Password",
    component: () => import("./pages/Password.vue")
  },
  {
    path: '/viplist',
    name: "VipList",
    beforeEnter() {location.href = 'http://www.4artz.com/listavip'}
  }
];

export default authRoutes;
